const s = {
  name: "Speaker",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,20c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S15,22.8,15,20z M20,17c-1.7,0-3,1.3-3,3s1.3,3,3,3
			c1.7,0,3-1.3,3-3S21.7,17,20,17z"/>
		<path class="st0" d="M12,20c0-4.4,3.6-8,8-8v-2c-5.5,0-10,4.5-10,10H12z"/>
		<path class="st0" d="M20,5C11.7,5,5,11.7,5,20s6.7,15,15,15c8.3,0,15-6.7,15-15S28.3,5,20,5z M7,20c0-7.2,5.8-13,13-13
			s13,5.8,13,13s-5.8,13-13,13S7,27.2,7,20z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31,0,20,0z M2,20c0-9.9,8.1-18,18-18s18,8.1,18,18
			s-8.1,18-18,18S2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Speaker
};
